export default __webpack_public_path__ + "static/media/640_store03-nl-web.bbc5f7f7.png";